import React from 'react'

import Header from './components/layout/Header'
import { APPBAR_HEIGHT } from './util/consts'
import AddToCartProvider from './features/cart/components/useAddToCartModal'
import DrawdownProvider from './features/drawdown/useDrawdownRequest'
import { PickUpStoreModalProvider } from './features/cart/components/PickUpStoreModal'
import AtomicProvider from './services/atomic/AtomicProvider'
import { AccountSwitcherProvider } from './features/azure-b2c/components/AccountSwitcherProvider'
import { PageLayout } from './AppPage'

export const AppProviders: React.FC<{
  children: React.ReactNode
  ready: boolean
  fallback: React.ReactNode
}> = (props) => {
  if (props.ready) {
    return (
      <AccountSwitcherProvider>
        <AtomicProvider>
          <PickUpStoreModalProvider>
            <AddToCartProvider>
              <DrawdownProvider>
                <Header appbarHeight={APPBAR_HEIGHT} />
                <PageLayout>{props.children}</PageLayout>
              </DrawdownProvider>
            </AddToCartProvider>
          </PickUpStoreModalProvider>
        </AtomicProvider>
      </AccountSwitcherProvider>
    )
  } else {
    return props.fallback
  }
}

export default AppProviders
